import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from '../utils/baseQueryWithAuth';

export const TAGS = {
  USERS: 'Users',
  PROJECTS: 'Projects',
  // Add more tags as needed
  ALL: 'All'
};

export const GLOWApiClient = createApi({
  reducerPath: 'glow_api',
  baseQuery: baseQueryWithAuth,
  tagTypes: Object.values(TAGS),
  endpoints: () => ({}),
});

export default GLOWApiClient;

// Fonction de diagnostic pour inspecter la configuration RTK Query
export function debugRTKQueryConfig() {
  const apiEndpoints = GLOWApiClient.endpoints;
  
 
  // Vérifier si les endpoints critiques existent
  const criticalEndpoints = [
    'usersClientsRetrieve',
    'salonsRetrieve',
    'schedulesSchedulesByTeamMemberRetrieve',
    'appointmentsCreate'
  ];
  
  criticalEndpoints.forEach(endpoint => {
    if (apiEndpoints[endpoint]) {
      console.log(`Endpoint ${endpoint}: Configuré correctement`);
    } else {
      console.error(`Endpoint ${endpoint}: NON CONFIGURÉ - MANQUANT`);
    }
  });
  
  return apiEndpoints;
}

export const invalidateCache = (api, tags = [TAGS.ALL]) => {
  return api.util.invalidateTags(tags);
};

export const refetchQueries = async (api, endpoints = [], args = []) => {
  const promises = endpoints.map((endpoint, index) => {
    const queryArg = args[index] !== undefined ? args[index] : undefined;
    return api.endpoints[endpoint].initiate(queryArg, { 
      forceRefetch: true 
    });
  });
  
  return Promise.all(promises);
};
